// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5478":"64c9508a","8394":"64c9508a","8598":"64c9508a"}[chunkId] + ".chunk.css";
};